import { useMutation } from "react-query";
import { updateAddress } from "~/components/Forms/DealerPassportForm2/requests/updateAddress";

export default function useUpdateAddress() {
  return useMutation({
    mutationFn: ({ dealerId, data }: { dealerId: string; data: any }) =>
      updateAddress(dealerId, data),
  });
}
